import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

// windowオブジェクトにgtagを追加
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

const FinalCTA: React.FC = () => {
  const handleFormClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17931041617/eH8qCOvAwPIbENH2l-ZC',
        'value': 1.0,
        'currency': 'JPY'
      });
    }
  };

  const handleLineClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17931041617/eH8qCOvAwPIbENH2l-ZC',
        'value': 1.0,
        'currency': 'JPY'
      });
    }
  };

  return (
    <>
      {/* 関連ページへの誘導 */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-8">
            お悩み別の詳しい解説
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <Link
              to="/kyoyu-meigi"
              className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg hover:border-amber-300 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mb-4 group-hover:bg-amber-200 transition-colors">
                <i className="ri-group-line text-amber-600 text-xl"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">共有名義・相続未分割</h3>
              <p className="text-sm text-gray-600 mb-4">共有者との交渉から共有物分割請求まで、弁護士が確実に解決へ導きます。</p>
              <span className="inline-flex items-center text-amber-600 text-sm font-medium group-hover:gap-2 transition-all">
                詳しく見る <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>
            
            <Link
              to="/nouchi"
              className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg hover:border-amber-300 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mb-4 group-hover:bg-amber-200 transition-colors">
                <i className="ri-seedling-line text-amber-600 text-xl"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">農地処分</h3>
              <p className="text-sm text-gray-600 mb-4">農地法の規制対応、農業委員会への許可申請、国庫帰属制度まで対応。</p>
              <span className="inline-flex items-center text-amber-600 text-sm font-medium group-hover:gap-2 transition-all">
                詳しく見る <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>
            
            <Link
              to="/blog"
              className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg hover:border-amber-300 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mb-4 group-hover:bg-amber-200 transition-colors">
                <i className="ri-article-line text-amber-600 text-xl"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">コラム・お役立ち情報</h3>
              <p className="text-sm text-gray-600 mb-4">山林・農地・空き家の処分方法を弁護士がわかりやすく解説します。</p>
              <span className="inline-flex items-center text-amber-600 text-sm font-medium group-hover:gap-2 transition-all">
                記事を読む <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section id="contact" className="relative py-20 bg-gradient-to-br from-amber-50 via-white to-amber-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center px-4 py-2 bg-amber-100 text-amber-800 rounded-full text-sm font-medium mb-6">
            <i className="ri-heart-pulse-line mr-2"></i>
            お一人で抱え込まず、一緒に解決しましょう
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            まずはお気軽にご相談ください
          </h2>
          
          <p className="text-xl text-gray-700 mb-2">
            どんな小さなお悩みでも構いません
          </p>
          <p className="text-lg text-gray-600 mb-4">
            <i className="ri-time-line mr-2"></i>
            3営業日以内に心を込めてお返事いたします
          </p>
          <p className="text-lg text-gray-600 mb-8">
            <i className="ri-video-line mr-2"></i>
            遠方の方はウェブ会議での打合せにも対応いたします
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="outline"
              size="lg"
              href="https://forms.gle/zPw2NXXr6K7nXgAm6"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleFormClick}
              className="flex items-center justify-center gap-3 bg-white text-amber-600 hover:bg-gray-50 border-amber-600 shadow-lg"
            >
              <i className="ri-mail-heart-line text-xl"></i>
              メールで初回相談の予約
            </Button>
            
            <Button
              variant="secondary"
              size="lg"
              href="https://lin.ee/34dhahY"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleLineClick}
              className="flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white border-green-500 shadow-lg"
            >
              <i className="ri-line-fill text-xl"></i>
              LINEで初回相談の予約
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default FinalCTA;
